// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_CarregaCategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/servicos_categorias/carrega_categorias
 *
 * Returns a list of every service category (config_servicos_categorias) ordered
 * by name. The legacy shape emits the array directly under `dados`.
 */
import type { ServicosCategorias_CategoriaRow } from './ServicosCategorias_CategoriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicosCategorias_CarregaCategoriasResponseDados = ServicosCategorias_CategoriaRow[];

export type ServicosCategorias_CarregaCategoriasResponse = ApiResponse<ServicosCategorias_CarregaCategoriasResponseDados>;

registerResponseContract('ServicosCategorias_CarregaCategoriasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servicoscategoria_id:                  { type: 'number',  required: true },
      servicoscategoria_nome:                { type: 'string',  required: true },
      servicoscategoria_prazo_retorno_dias:  { type: 'number',  required: true },
      servicoscategoria_prazo_garantia_dias: { type: 'number',  required: true },
      servicoscategoria_produtos_associados: { type: 'number',  required: true },
    },
  },
})
